import { TabSwitch } from "@/components/TabSwitch";
import { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import LessonDetails from "./lesson-details";
import { Button, Icon } from "@/components";
import {
  useSearchParams,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import DateSelect from "./date-select";
import { useGetTeacherLessons } from "@/services/teachers/get";
import { useLessonContext } from "@/contexts/lesson-context";
import { ClassType } from "./class-type/index";
import { Summary } from "./summary";

function EnrolmentTabs({ close }: { close: () => void }) {
  const [searchParams] = useSearchParams();
  const urlParams = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { updateValues, values } = useLessonContext();
  const { lessons, isLoading } = useGetTeacherLessons({
    id: urlParams.teacher_id ?? "",
  });

  const tabList = useMemo(() => {
    return (
      lessons?.result?.languagesTaught.map((language) => ({
        name: language.name,
        label: language.name,
      })) ?? []
    );
  }, [lessons]);
  const [activeTab, setActiveTab] = useState(tabList?.[0]?.name);

  const activeLessons = useMemo(() => {
    return lessons?.result?.languagesTaught.find(
      (lesson) => lesson.name === activeTab,
    );
  }, [activeTab, lessons]);
  const activeLessonDetails = useMemo(() => {
    const lessonId = searchParams.get("lesson");
    if (lessonId)
      return activeLessons?.lessons.find(
        (lesson) => lesson.lessonId === lessonId,
      );
    return null;
  }, [searchParams.get("lesson")]);

  const handleClickEnrolment = (
    lessonId: string,
    lesson: {
      name: string;
      description: string;
      teacherId: string;
      lessonType: string;
      minPrice: number;
      isPromo?: boolean;
      price?: any;
      duration?: number;
    },
    type?: string,
  ) => {
    const params = new URLSearchParams(searchParams);
    if (type === "trial") {
      params.set("lesson", lessonId);
      params.set("sublesson", lesson.isPromo ? "free_trial" : "trial_lesson");
      navigate(`${location.pathname}?${params.toString()}`);

      if (lesson.isPromo) {
        updateValues({
          ...values,
          lessonId: lessonId,
          item: lesson,
          marchantId: lesson.teacherId,
          type: "free_trial",
          tax: lesson.price * 0.06,
          totalPrice: eval(lesson.price + lesson.price * 0.06),
          amount: 0,
          quantity: 1,
          duration: 30,
        });
      } else {
        updateValues({
          ...values,
          lessonId: lessonId,
          item: lesson,
          marchantId: lesson.teacherId,
          type: "trial_lesson",
          tax: lesson.price * 0.06,
          totalPrice: eval(lesson.price + lesson.price * 0.06),
          amount: lesson.price,
          duration: lesson.duration ?? 30,
          quantity: 1,
        });
      }
    } else {
      params.set("lesson", lessonId);
      updateValues({
        ...values,
        lessonId: lessonId,
        item: lesson,
        marchantId: lesson.teacherId,
        type: "",
      });
      navigate(`${location.pathname}?${params.toString()}`);
    }
  };

  useEffect(() => {
    if (!!tabList) {
      setActiveTab(tabList?.[0]?.name);
    }
  }, [tabList]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (searchParams.get("summary")) {
    return (
      <div>
        <Button
          variant="neutral"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          <Icon name="left_arrow" />
          <span>Back</span>
        </Button>
        <Summary />
      </div>
    );
  }
  if (searchParams.get("class")) {
    return (
      <div>
        <Button
          variant="neutral"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          <Icon name="left_arrow" />
          <span>Back</span>
        </Button>
        <ClassType />
      </div>
    );
  }

  if (searchParams.get("sublesson")) {
    return (
      <div>
        <Button
          variant="neutral"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          <Icon name="left_arrow" />
          <span>Back</span>
        </Button>
        <DateSelect />
      </div>
    );
  }
  if (searchParams.get("lesson")) {
    return (
      <div>
        <Button
          variant="neutral"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          <Icon name="left_arrow" />
          <span>Back</span>
        </Button>
        <LessonDetails lesson={activeLessonDetails} />
      </div>
    );
  }
  const trialLesson = lessons?.result?.trailLesson
    ? lessons?.result?.trailLesson
    : null;

  return (
    <div className="enrolment--tabs">
      <Button
        variant="neutral"
        className="enrolment--tabs__close-btn"
        onClick={close}
      >
        <Icon name="downArrow" />
        <span>Hide</span>
      </Button>
      <TabSwitch
        onSelectedChange={setActiveTab}
        list={tabList}
        defaultSelected={tabList?.[0]?.name}
      />
      <div className="enrolment--container">
        <>
          {trialLesson === null ? null : (
            <div key={trialLesson?.lessonId} className="enrolment-lesson-card">
              <p className="lesson-title">{trialLesson?.title}</p>
              <p className="lesson-description">{trialLesson?.description}</p>
              <button
                className="enrolment-btn"
                onClick={() =>
                  handleClickEnrolment(
                    trialLesson?.lessonId,
                    trialLesson,
                    "trial",
                  )
                }
              >
                continue
              </button>
            </div>
          )}
          {activeLessons?.lessons.map((lesson) => (
            <div key={lesson?.lessonId} className="enrolment-lesson-card">
              <p className="lesson-title">{lesson?.name}</p>
              <p className="lesson-description">{lesson?.description}</p>
              <button
                className="enrolment-btn"
                onClick={() => handleClickEnrolment(lesson?.lessonId, lesson)}
              >
                continue
              </button>
            </div>
          ))}
        </>
      </div>
    </div>
  );
}

export default EnrolmentTabs;
